import React from 'react';
import { Button, Grid } from '@material-ui/core';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import styled from 'styled-components';
import { FieldErrors, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmailTextField } from '../common/emailTextField';
import { ResetPasswordFormValues } from '../common/interfaces';
import { SpinnerComponent } from '../common/spinnerComponent';

interface ResetPasswordFormProps {
    submitResetPassword: (data: ResetPasswordFormValues) => void;
    fieldsErrors: FieldErrors;
    handleSubmit: UseFormMethods['handleSubmit'];
    register: UseFormMethods['register'];
    loading: boolean;
}

export const ResetPasswordForm = ({ 
    submitResetPassword,  
    fieldsErrors, 
    handleSubmit, 
    register,
    loading
}: ResetPasswordFormProps) => {
    const { t } = useTranslation();

    return (
        <Grid item xs={12}>
            <form onSubmit={handleSubmit(submitResetPassword)}>
                <Grid container item xs={12}>
                    <EmailTextField
                        register={register}
                        fieldsErrors={fieldsErrors}
                        label={t('emailAddress')}
                    />
                </Grid>
                <Grid container item direction='row' alignItems='center' xs={12}>
                    <Grid container item xs={12}>
                        <SubmitResetPasswordButton 
                            color='primary' 
                            fullWidth 
                            type='submit' 
                            variant='contained'
                            disableElevation
                        >
                            <StyledEmailOcon/>
                            {loading && <SpinnerComponent />}
                            {t('sendEmail')}
                        </SubmitResetPasswordButton>
                    </Grid>
                </Grid>
            </form>
        </Grid>
    );
};

const SubmitResetPasswordButton = styled(Button)`
    background-color: #0083C6;
`;

const StyledEmailOcon = styled(MailOutlineIcon)`
    font-size: 15;
    margin-right: 5px;
`;
